import { Action } from 'redux';
import { IAsynchronouslyLoadedValue, PoReviewDraft } from '../types';

export const PO_REVIEW_DRAFT_GET = 'poReviewDraft/get';
export const PO_REVIEW_DRAFT_LOADED = 'poReviewDraft/loaded';
export const PO_REVIEW_DRAFT_CLEAR = 'poReviewDraft/clear';
export const PO_REVIEW_DRAFT_PO_NUMBER_CHANGED = 'poReviewDraftPoNumber/changed';
export const PO_REVIEW_DRAFT_SHIP_DATE_CHANGED = 'poReviewDraftShipDate/changed';
export const PO_REVIEW_DRAFT_DELIVERY_DATE_CHANGED = 'poReviewDraftDeliveryDate/changed';
export const PO_REVIEW_DRAFT_SHIPPING_LOCATION_CODE_CHANGED = 'poReviewDraftShippingLocationCode/changed';
export const PO_REVIEW_DRAFT_ROW_ITEM_CHANGED = 'poReviewDraftRowItem/changed';
export const PO_REVIEW_DRAFT_ROW_QUANTITY_CHANGED = 'poReviewDraftRowQuantity/changed';
export const PO_REVIEW_DRAFT_LINE_ADDED = 'poReviewDraftLine/added';
export const PO_REVIEW_DRAFT_LINE_REMOVED = 'poReviewDraftLine/removed';
export const PO_REVIEW_DRAFT_STATUS_CHANGED = 'poReviewDraftStatus/changed';

export interface PoReviewDraftGetAction extends Action {
    type: typeof PO_REVIEW_DRAFT_GET;
    payload: IAsynchronouslyLoadedValue<PoReviewDraft>;
}

export interface PoReviewDraftLoadedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_LOADED;
    payload: IAsynchronouslyLoadedValue<PoReviewDraft>;
}

export interface PoReviewDraftClearAction extends Action {
    type: typeof PO_REVIEW_DRAFT_CLEAR;
}

export interface PoReviewDraftPoNumberChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_PO_NUMBER_CHANGED;
    payload: string;
}

export interface PoReviewDraftShipDateChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_SHIP_DATE_CHANGED;
    payload: string;
}

export interface PoReviewDraftDeliveryDateChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_DELIVERY_DATE_CHANGED;
    payload: string;
}

export interface PoReviewDraftShippingLocationCodeChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_SHIPPING_LOCATION_CODE_CHANGED;
    payload: string;
}

export interface PoReviewDraftRowItemChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_ROW_ITEM_CHANGED;
    payload: { rowId: string; itemId?: string };
}

export interface PoReviewDraftRowQuantityChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_ROW_QUANTITY_CHANGED;
    payload: { rowId: string; quantity: string };
}

export interface PoReviewDraftLineAddedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_LINE_ADDED;
    payload: { rowId: string };
}

export interface PoReviewDraftLineRemovedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_LINE_REMOVED;
    payload: { rowId: string };
}

export interface PoReviewDraftStatusChangedAction extends Action {
    type: typeof PO_REVIEW_DRAFT_STATUS_CHANGED;
    payload: string;
}

export type PoReviewDraftActions =
    | PoReviewDraftGetAction
    | PoReviewDraftLoadedAction
    | PoReviewDraftClearAction
    | PoReviewDraftPoNumberChangedAction
    | PoReviewDraftShipDateChangedAction
    | PoReviewDraftDeliveryDateChangedAction
    | PoReviewDraftShippingLocationCodeChangedAction
    | PoReviewDraftRowItemChangedAction
    | PoReviewDraftRowQuantityChangedAction
    | PoReviewDraftLineAddedAction
    | PoReviewDraftStatusChangedAction
    | PoReviewDraftLineRemovedAction;
